import React from "react";
import { Reveal } from "../components/Section";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="relative py-20 px-6 text-center bg-ivory border-t border-gold/20">
      <Reveal>
        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-6">Terima Kasih</p>
        <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-4">
          Kevin <span className="font-script gold-text">&</span> Angeline
        </h2>
        <p className="text-charcoal/60 max-w-md mx-auto leading-relaxed font-serif italic">
          Merupakan suatu kehormatan dan kebahagiaan bagi kami apabila Bapak/Ibu/Saudara/i
          berkenan hadir dan memberikan doa restu kepada kami.
        </p>
        <div className="mt-10 text-xs tracking-[0.25em] uppercase text-charcoal/40">
          Made with love · Medan 2026
        </div>
      </Reveal>
    </footer>
  );
}
